import { ActionEnum } from "../action.enum";
import { TriggerData } from "../../models/trigger/TriggerData.model";
import { JobTemplateConditionType } from "../../enums/job_template/JobTemplateConditionType";
import { TriggerCondition } from "../../enums/trigger/TriggerCondition";


export namespace TriggerManagerAction {

  export class Initialize {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_INITIALIZE;

    constructor(
      public routineId: string,
      public isTemplate: boolean = false,
      public moduleId: string | null = null,
      public moduleVersion: number | null = null
    ) { }
  }

  export class FetchTriggers {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_FETCH_TRIGGERS;

    constructor(public afterSave: boolean = false) { }
  }

  export class Create {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_CREATE;
  }

  export class TakeOverTriggersFromTemplate {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_TAKE_OVER_TRIGGERS_FROM_TEMPLATE;
  }

  export class Edit {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_EDIT;

    constructor(public triggerId: string) {}
  }

  export class UpdateManagedTrigger {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_UPDATE_MANAGED_TRIGGER;

    constructor(public triggerData: TriggerData) {}
  }

  export class Save {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_SAVE;

    constructor() {}
  }

  export class Delete {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_DELETE;

    constructor(public triggerId: string) { }
  }

  export class SelectCondition {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_SELECT_CONDITION;

    constructor(public triggerCondition: TriggerCondition | JobTemplateConditionType) {}
  }

  export class CloseManager {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_CLOSE_MANAGER;

    constructor() {}
  }

  export class ResetExceptTriggers {
    static readonly type: ActionEnum = ActionEnum.TRIGGER_MANAGER_RESET;
  }
}
